import React, {Component} from "react";
import Header from "./Header";
import Footer from "./Footer";


class Layout extends Component {

	render() {
		return ( <div style={{minHeight: "100vh", display: "flex", flexDirection: "column"}}>
			<Header selectedTab={this.props.selectedTab}/>
			<div className="masterContent" style={{flex: 1}}>
				{this.props.children}
			</div>
			<Footer/>
		</div>
		);
	}
}

export default Layout;
